<template>
  <section style="background-color: #fff">
    <!-- 首页banner -->
    <div class="workshop-banner">
      <div class="workshop-title">{{ $t('Gattaran_Homepage__upog' /*欢迎访问Gattaran*/) }}</div>
      <!-- <div class="workshop-description">了解发现更多加特兰的精彩内容，如需合作可联系liulu@didiglobal.com</div> -->
      <!-- 申请权限 -->
      <pb-button type="primary" class="workshop-button" @click="toApply()">{{
        $t('Gattaran_Homepage__XQjL' /** 申请权限 */)
      }}</pb-button>
      <pb-button type="primary" class="learning-center-button" @click="toLearningCenter()">{{
        $t('FoodOpB_entrance_Learning_Centre_ENzd' /** 学习中心 */)
      }}</pb-button>
      <!-- 历史访问 -->
      <pb-card class="list-card">
        <div class="title">{{ $t('Gattaran_Homepage__Tchu' /*最近访问*/) }}</div>
        <pb-skeleton :loading="tagsLoading" animated :count="1">
          <template slot="template">
            <div class="tags-wrap">
              <Fragment v-for="i in 8" :key="i">
                <div class="tags">
                  <pb-skeleton-item variant="div" style="width: 80px; height: 32px" />
                </div>
              </Fragment>
            </div>
          </template>
          <template>
            <Fragment>
              <div class="tags-wrap">
                <Fragment v-if="history.length > 0">
                  <div v-for="item in history" :key="item.id" class="tags">
                    <!-- <pb-tag checkable-tag="choosable" size="large" @click="handleClick(item)">{{ item.moduleName }}</pb-tag> -->
                    <pb-button type="primary" secondary @click="handleClick(item)">{{
                      item.moduleName
                    }}</pb-button>
                  </div>
                </Fragment>
                <Fragment v-else>
                  <div class="no-record">{{ $t('Gattaran_Homepage__nRqe' /*暂无访问记录*/) }}</div>
                </Fragment>
              </div>
            </Fragment>
          </template>
        </pb-skeleton>
      </pb-card>
    </div>
    <pb-skeleton :loading="loading" animated :count="1">
      <template slot="template">
        <div class="workshop-side">
          <Fragment v-for="i in 6" :key="i">
            <div style="width: 50%">
              <pb-skeleton-item variant="div" style="width: 95%; height: 216px; margin-top: 5px" />
            </div>
          </Fragment>
        </div>
      </template>
      <!-- 业务线 -->
      <template>
        <Fragment>
          <div class="workshop-side">
            <div
              v-for="item in sides"
              :key="item.serviceName"
              class="card"
              @click="toModule(item.key)"
            >
              <div class="card-header">
                <img class="logo" :src="removeProtocol(item.icon)" />
                <span>{{ item.serviceName }}</span>
              </div>
              <div class="card-content">{{ item.description }}</div>
              <div class="card-link">{{ $t('Gattaran_Homepage__YscW' /*更多*/) }} ></div>
            </div>
          </div>
        </Fragment>
      </template>
    </pb-skeleton>
    <Footer />
    <ReViewDriver />
  </section>
</template>

<script>
import { useAppStore, useMenuStore } from '@/store';
import { ref, watchEffect } from 'vue';
import { useRecentHistory } from '@/services/use-api';
import ReViewDriver from '@/pages/layout/components/reViewDriver';
import { getMatchPathByNodeKey } from '@/utils/route-menu';
import { isExternal } from '@/utils';
import { rmProtocol } from '@/utils/tools';
import { setRecentVisit } from '../overview/service';

export default {
  components: {
    ReViewDriver,
    Footer: () => import('@/components/footer'),
  },
  setup() {
    const sides = ref([]);
    const [history, setHistory, isLoading] = useRecentHistory();
    const loading = ref(true);
    const appStore = useAppStore();
    setHistory();
    watchEffect(() => {
      sides.value = appStore.sideInfo || [];
      if (sides.value.length > 0) loading.value = false;
    });
    return {
      sides,
      history,
      loading,
      tagsLoading: isLoading,
    };
  },
  methods: {
    toModule(val) {
      const menuStore = useMenuStore();
      menuStore.initCurrentSideList(`/${val}`); // 设置目标模块概述页面数据
      this.$router.push(`/${val}/summary`);
    },
    toApply() {
      this.$router.push('/gtr_console/authmanage/application/add');
    },
    toLearningCenter() {
      window.open('https://food-learning.didiglobal.com/');
    },
    removeProtocol(url) {
      return rmProtocol(url);
    },
    handleClick(val) {
      const { nodeKey, activeMicroAppName = '' } = val;
      const { matchPath } = getMatchPathByNodeKey(nodeKey);
      // 如果matchPath是外链，则新窗口打开外链
      if (isExternal(matchPath)) {
        window.open(matchPath);
      } else {
        // 否则浏览器正常push
        this.$router.push(matchPath);
      }
      // 首页最近访问增加最近访问
      setRecentVisit({
        nodeKey: nodeKey,
        activeMicroAppName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.workshop-banner {
  background: url('./assets/banner.png') no-repeat center;
  background-size: cover;
  width: 100%;
  height: 358px;
}
.workshop-title {
  font-family: DiDiSans-Pro-Bold;
  font-size: 48px;
  font-weight: bold;
  color: #000000;
  line-height: 56px;
  padding-top: 64px;
  padding-left: 120px;
}
.workshop-description {
  width: 730px;
  padding-top: 12px;
  padding-left: 120px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #595c66;
  line-height: 24px;
  font-weight: 400;
}
.workshop-button {
  height: 40px;
  border-radius: 24px;
  margin-left: 120px;
  margin-top: 32px;
  padding: 8px 24px;
  font-family: DiDiSans-Pro-Bold;
  font-size: 16px;
  font-weight: normal;
}
.learning-center-button {
  height: 40px;
  border-radius: 24px;
  margin-left: 16px !important;
  margin-top: 32px;
  padding: 8px 24px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #282b33;
  font-weight: 600;
  background-color: #ffffff;
  border-color: #ffffff;
}
.list-card {
  width: auto;
  margin: 64px 120px 24px;
  border: 0;
  border-radius: 8px;
  .title {
    font-family: DiDiSans-Pro-Bold;
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    line-height: 32px;
  }
}
.tags-wrap {
  margin-top: 20px;
  .tags {
    display: inline-block;
    margin: 0 8px 8px 0;
  }
  .no-record {
    font-size: 12px;
    color: #8d9099;
    font-weight: 400;
    text-align: center;
  }
}
.workshop-side {
  margin: 106px 120px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .card {
    //height: 212px;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 24px 24px 48px 24px;
    width: 50%;
    position: relative;
    &:hover {
      background: #f8f8fa;
      cursor: pointer;
      .card-link {
        background: #f8f8fa;
        transition: all 0.35s ease-in-out;
        transform: translateX(4px);
      }
    }
  }
  .card-header {
    display: flex;
    align-items: center;
    .logo {
      width: 56px;
      height: 56px;
      margin-right: 8px;
    }
    span {
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      font-weight: bold;
      color: #000000;
      line-height: 32px;
    }
  }
  .card-content {
    margin-top: 16px;
    font-family: DiDiSans-Pro-Regular;
    font-size: 16px;
    color: #595c66;
    line-height: 24px;
  }
  .card-link {
    font-family: DiDiSans-Pro-Medium;
    color: #ff7a45;
    line-height: 24px;
    position: absolute;
    bottom: 20px;
  }
}
</style>
